import type { DataLayerEvent } from "../types"

const validateEventData = (eventData: DataLayerEvent): boolean => {
  const issues: string[] = []

  if (!eventData.Resort) {
    issues.push("Resort name is missing")
  }
  if (!eventData.Language) {
    issues.push("Language is missing")
  }
  if (!eventData.event) {
    issues.push("Event name is missing")
  }

  if (issues.length > 0) {
    console.warn(`Event validation issues: ${issues.join(", ")}`)
    return false
  }

  return true
}

export const pushToDataLayer = (eventData: DataLayerEvent): void => {
  if (!window.dataLayer) return

  if (!validateEventData(eventData)) return

  try {
    window.dataLayer.push(eventData)
  } catch (error) {
    console.error("Error pushing to dataLayer:", error)
  }
}
